<div class="sr-only" role="status" aria-live="assertive" aria-atomic="true">{{ statusMessage }}</div>
<zbp-data-table
  [columns]="columns"
  [rows]="rows"
  [isLoading]="isLoading"
  [noResultsMessage]="noDataMessage"
  [pageSize]="pageSize"
  [collectionSize]="collectionSize"
  [page]="page"
  (pageChange)="onPageChange($event)"
></zbp-data-table>
